<!-- eslint-disable -->
<template lang="pug">
    .table-responsive-container
        .table-responsive
            table.points__table
                thead.points__thead
                    tr.points__tr--border
                        td.points__td(v-if="user.type !== 'student'")
                            | {{ $i18n.t('common.common_userType_student') }}
                        td.points__td
                            | {{ $i18n.t('historyTable.historyTable_title_dateScoring') }}
                        td.points__td
                            | {{ $i18n.t('points.points_historyTable_points') }}
                        td.points__td
                            | {{ $i18n.t('historyTable.historyTable_title_source') }}
                tbody
                    points-preview(v-for='record in items', :record='record', :key='record.id')
</template>

<script>
    /*eslint-disable*/
    import {mapState} from 'vuex';
    import PointsPreview from './Preview.vue';

    export default {
        props: ['items'],
        computed: {
            ...mapState({
                user: state => state.auth.user
            }),
        },
        components: {
            PointsPreview
        }
    }
</script>

<style lang="scss" scoped>
    .table-responsive-container {
        display: grid;
    }

    .table-responsive {
        overflow-x: auto;
    }

    .points__table {
        margin: 30px 0;
        width: 100%;
        text-align: left;
        border-collapse: collapse;
    }

    .points__thead {
        font-weight: 500;
        font-size: 16px;
        line-height: 19px;
        background-color: #E6E6F8;
    }

    .points__td {
        padding: 13px 8px;
        @include media($md) {
            padding: 10px 20px;
        }
        @include media($lg) {
            padding: 10px 30px;
        }
    }

    .points__tr--border {
        border-bottom: 1px solid #E6E6F8;
    }
</style>
